export default function LaunchPage() {
  return (
    <div className="relative py-16 overflow-hidden">
      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="text-lg max-w-prose mx-auto">
          <h1>
            <span className="bg-clip-text block text-center text-transparent bg-gradient-to-tr dark:from-brand-400 from-brand-500 via-teal-500 dark:via-teal-300 to-yellow-700 dark:to-amber-400 font-semibold ">
              Hello again,
            </span>
            <span className="font-sans text-zinc-800 dark:text-zinc-100 tracking-tighter block font-extrabold text-4xl sm:text-6xl text-center">
              Good Neighbour
            </span>
          </h1>
          <p className="mt-8 text-xl text-zinc-500 dark:text-zinc-200 leading-8">
            It's been a minute since we last chatted. If this is your first time, welcome. Thanks for coming by to find
            out more about what we're doing.
          </p>
        </div>
        <div className="mt-6 prose prose-zinc prose-lg text-zinc-500 dark:text-zinc-200 mx-auto">
          <p>
            Good Neighbour has been a labour of love for close to 6 years for me. I have had some awful experiences
            living in units (roof cave-ins, leaky ceilings etc) and playing the competitive game of securing an
            apartment.
          </p>
          <p>
            At a certain point, I just figured that there has to be another way. Why do renters lack the information and
            resources to make smart financial decisions? Why do we turn our noses up at renters? Often they are paying
            the mortgage of a property owner with none of the benefits.
          </p>
          <h2>60 days to launch</h2>
          <p>
            Good Neighbour was always a side gig. There are no investors or people putting money into the project. Every
            minute spent working on Good Neighbour is a dollar not earned from another project.
          </p>
          <p>
            But, some things are worth doing. There's a strong intrinsic push to solve a problem as "normal" as renting.
            So, for the last two months, I've just spent every day focusing on this site. Knowing that I'd watch my bank
            account go down.
          </p>
          <p>
            Yet, I did it. It's here. The main drive throughout was knowing that I was going to make something that
            helped others. 60 days of being my own worst critic and making silly mistakes as I asked others in the
            industry to work together.
          </p>
          <blockquote>
            <p>There's no money in focusing on renters. You should invest in helping landlords.</p>
          </blockquote>
          <p>
            That line was a common response from similar rental products. That everything that I was doing was for
            naught, because it's only about making money for landlords.
          </p>
          <p>
            Which fine, they run a business designed to leverage tenants and put money into landlords pockets. But, who
            are we forgetting?
          </p>
          <figure>
            <img
              className="w-full rounded-lg"
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&w=1310&h=873&q=80&facepad=3"
              alt=""
              width={1310}
              height={873}
            />
            <figcaption>Sagittis scelerisque nulla cursus in enim consectetur quam.</figcaption>
          </figure>
          <h2>Everything you need to get up and running</h2>
          <p>
            Purus morbi dignissim senectus mattis <a href="#">adipiscing</a>. Amet, massa quam varius orci dapibus
            volutpat cras. In amet eu ridiculus leo sodales cursus tristique. Tincidunt sed tempus ut viverra ridiculus
            non molestie. Gravida quis fringilla amet eget dui tempor dignissim. Facilisis auctor venenatis varius nunc,
            congue erat ac. Cras fermentum convallis quam.
          </p>
          <p>
            Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus enim. Mattis mauris semper sed amet vitae
            sed turpis id. Id dolor praesent donec est. Odio penatibus risus viverra tellus varius sit neque erat velit.
          </p>
        </div>
      </div>
    </div>
  )
}
